import { __require as r } from "../InputData.mjs";
var t, e;
function a() {
  if (e) return t;
  e = 1;
  const a = r();
  return t = (r, t) => {
    let e = new a(r);
    const s = Object.keys(r.customParameters ?? {}).length > 0;
    for (let r in t) e.add(r, t[r]);
    if (s) for (let t in r.customParameters) e.addCustomParameter(t, r.customParameters[t]);
    return e.data;
  };
}
export { a as __require };